import { render, staticRenderFns } from "./SubscribeDialog.vue?vue&type=template&id=6592c4f7&"
import script from "./SubscribeDialog.vue?vue&type=script&lang=js&"
export * from "./SubscribeDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6592c4f7')) {
      api.createRecord('6592c4f7', component.options)
    } else {
      api.reload('6592c4f7', component.options)
    }
    module.hot.accept("./SubscribeDialog.vue?vue&type=template&id=6592c4f7&", function () {
      api.rerender('6592c4f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceReal/components/PriceReal/SubscribeDialog.vue"
export default component.exports